import React, { Component, useState } from "react";
import { useLocation } from 'react-router-dom';
import axios from "axios"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import SimpleModal from '../../components/SimpleModal/SimpleModal';

class RemoveDataForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phoneState: '',
            phone: '',
            study: '',
            type: '',
            date: '',
            location: '',
            typeofrequest: '',
            formtype: this.props.location.pathname.toUpperCase().indexOf("CCPA") == -1 ? "GDPR" : "CCPA",
            submittedstate: 'not-submitted'
        };
        this.messages = {
            success: {
                header: `Your ${this.state.formtype} Request has been successfully submitted!`,
                body: `Thank you for submitting your ${this.state.formtype} request and for trusting us with your information.We will process your request as soon as possible.`,
                button: "Return to Privacy Policy"
            },
            fail: {
                header: 'Sorry, there is something wrong on our end',
                body: 'Please call our number at 1(800) 983-1323 to submit this request.',
                button: "Return to Privacy Policy"
            }
        };
    }

    formPageContent() {
        return (
            <div className="col-sm-8 col-sm-offset-4">
                <h1>{this.state.formtype} Request Form</h1>
                <p>All fields are required.</p>
                <form id="erase-my-data-form" className="form-horizontal" onSubmit={this.handleSubmit.bind(this)}>
                    <div className="form-group">
                        <label htmlFor="input-name" className="col-sm-4 control-label">Full name</label>
                        <div className="col-sm-8">
                            <input type="text" className="form-control" id="input-name" placeholder="Full name" value={this.state.name} onChange={this.onSimpleInputChange.bind(this)} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-email" className="col-sm-4 control-label">Email</label>
                        <div className="col-sm-8">
                            <input
                                type="email"
                                className="form-control"
                                id="input-email"
                                placeholder="name@example.com"
                                value={this.state.email}
                                onChange={this.onSimpleInputChange.bind(this)}
                                required
                                pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-phone" className="col-sm-4 control-label">Phone number</label>
                        <div className="col-sm-8">
                            <PhoneInput
                                country={'us'}
                                value={this.state.phoneState}
                                onChange={this.handlePhoneOnChange.bind(this)}
                                preferredCountries={['us']}
                                placeholder="Enter your phone number"
                                inputStyle={{ 'width': '100%' }}
                                inputProps={{ required: false }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-study" className="col-sm-4 control-label">Subject matter of the Research Study</label>
                        <div className="col-sm-8">
                            <input type="text" className="form-control" id="input-study" placeholder="Please provide as much detail as possible" value={this.state.study} onChange={this.onSimpleInputChange.bind(this)} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-type" className="col-sm-4 control-label">Type of Research Study</label>
                        <div className="col-sm-8">
                            <input type="text" className="form-control" id="input-type" placeholder="(i.e. focus group, screening, etc.)" value={this.state.type} onChange={this.onSimpleInputChange.bind(this)} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-date" className="col-sm-4 control-label">Date of Research Study</label>
                        <div className="col-sm-8">
                            <DatePicker
                                selected={this.state.date}
                                onChange={this.onDateChange}
                                todayButton="Today"
                                popperPlacement="top"
                                className="form-control"
                                style={{ 'width': '100%' }}
                                dateFormat="MMMM d, yyyy"
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-location" className="col-sm-4 control-label">Location where personal information was collected</label>
                        <div className="col-sm-8">
                            <input type="text" className="form-control" id="input-location" placeholder="" value={this.state.location} onChange={this.onSimpleInputChange.bind(this)} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-type-of-request" className="col-sm-4 control-label">Type Of Request</label>
                        <div className="col-sm-8">
                            <textarea className="form-control" id="input-type-of-request" placeholder="" value={this.state.typeofrequest} onChange={this.onSimpleInputChange.bind(this)} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-10 col-sm-2">
                            <button type="submit" className="btn btn-default">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
            );
    }

    render() {
        let contents = this.formPageContent();
        if (this.state.submittedstate !== 'not-submitted') {
            let innerContent = this.state.submittedstate === 'submitted-success' ? this.messages.success : this.messages.fail;
            contents = <div className="col-sm-8 col-sm-offset-4">
                <h3>{innerContent.header}</h3>
                <p>{innerContent.body}</p>
                <a className='btn btn-primary' role='button' href = '/privacy'>{innerContent.button}</a>
            </div>;
        }
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <div className="row">
                    {contents}
                </div>
            </div>
        );
    }

    handlePhoneOnChange(value, data, event, formattedValue) {
        this.setState({ phoneState: value });
        this.setState({ phone: formattedValue });
    }

    onSimpleInputChange(event) {
        switch (event.target.id) {
            case 'input-name':
                this.setState({ name: event.target.value });
                break;
            case 'input-email':
                this.setState({ email: event.target.value });
                break;
                break;
            case 'input-study':
                this.setState({ study: event.target.value });
                break;
            case 'input-type':
                this.setState({ type: event.target.value });
                break;
            case 'input-location':
                this.setState({ location: event.target.value });
                break;
            case 'input-type-of-request':
                this.setState({ typeofrequest: event.target.value });
                break;
        }
    }

    onDateChange = date => {
        this.setState({
            date: date
        });
    };

    resetForm() {
        this.setState({
            name: '',
            email: '',
            phone: '',
            study: '',
            type: '',
            date: '',
            location: '',
            typeofrequest: ''
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        axios({
            method: "POST",
            url: "api/Home/SubmitEraseMyDataForm",
            data: JSON.stringify(this.state),
            headers: {
                'content-type':'application/json'
            }
        }).then((response) => {
            if (response.status == 200) {
                this.setState({ submittedstate: 'submitted-success' })
                this.resetForm();
            } else {
                this.setState({ submittedstate: 'submitted-error' })
            }
        }).catch((error) => {
            console.error(error);
            this.setState({ submittedstate: 'submitted-error' })
        })
    }
}

export default RemoveDataForm;